// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PSlidersOutlinedSvg from "@fishx/icons-svg/es/asn/PSlidersOutlined";
import FishxIcon from '../components/FishxIcon';

var PSlidersOutlined = function PSlidersOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PSlidersOutlinedSvg
  }));
};

PSlidersOutlined.displayName = 'PSlidersOutlined';
export default React.forwardRef(PSlidersOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PSlidersOutlined.js
// module id = 3633
// module chunks = 0